module.exports = __webpack_public_path__ + "static/img/05.cb7153b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wench/05.jpg
// module id = Vv7P
// module chunks = 1